import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6300d236")

_pushScopeId("data-v-6300d236")
const _hoisted_1 = { class: "tabContainer" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "d-flex mb_10" }
const _hoisted_4 = { class: "inputContainer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.labelKey)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            localizedKey: _ctx.labelKey,
            text: _ctx.labelValue,
            class: "input_title"
          }, null, 8, ["localizedKey", "text"]))
        : (_openBlock(), _createBlock("span", _hoisted_2)),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.locales, (langTab, i) => {
          return (_openBlock(), _createBlock("div", {
            class: ["tab", _ctx.selectedLocale == langTab ? 'active' : ''],
            key: i,
            onClick: ($event: any) => (_ctx.setInputLocale(langTab))
          }, _toDisplayString(langTab), 11, ["onClick"]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", { locale: _ctx.selectedLocale }, () => [
        _withDirectives(_createVNode("input", {
          type: _ctx.type,
          placeholder: _ctx.placeholder,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedInput = $event)),
          tabindex: _ctx.tabIndex
        }, null, 8, ["type", "placeholder", "tabindex"]), [
          [_vModelDynamic, _ctx.selectedInput]
        ])
      ], true)
    ])
  ]))
})